const BASE_CDN_URI = 'https://cdn.gembah.com/static'

// eslint-disable-next-line import/prefer-default-export
export const getBaseCDNuri = (URIappendix) => `${BASE_CDN_URI}/${URIappendix}`
